module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAMAAAC67D+PAAAAAXNSR0IB2cksfwAAAAlwSFlzAAAOwwAADsMBx2+oZAAAAE5QTFRFLYvvLYvvLYvvAAAALYvvLYvvLYvvLYvvLYvvLYvvLYvvLYvvLYvvLYvvLYvvLYvvLYvvLYvvLYvvLYvvLYvvLYvvLYvvLYvvLYvvLYvvMsV0HQAAABp0Uk5TD9WoAI3/CrsW/jgea3tGrl9aksGahjms9LiVdBTBAAAAQ0lEQVR4nDXKVw6AMBAD0RAz9F7D/S+Klizz9WQ5hCIqF0qIVWYNNP/adn7oYXBqhMmpGRatm9G8w2HUifVR153S8wJlgwJtO9Ab2wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/workOrder/womesicon3.png
// module id = VJHL
// module chunks = 1